import { DispatchType } from '../../../@types/redux-types'
import { getContacts } from '../../../api/contacts/contactsApi'
import { showMessage } from '../../reducers/message/messageFeature'
import { getContactsLoadSuccess } from '../../reducers/contact/contactFeature'

export const getContactsLoad = () => async (dispatch: DispatchType) => {
  try {
    const contacts = await getContacts()
    dispatch(getContactsLoadSuccess({ contacts: contacts }))
  } catch (error) {
    dispatch(showMessage({ message: 'unknown' }))
  }
}
